/* tslint:disable */
/* eslint-disable */
/**
 * All APIs
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SuggestedPrompt
 */
export interface SuggestedPrompt {
    /**
     * 
     * @type {string}
     * @memberof SuggestedPrompt
     */
    id: string;
    /**
     * Text to be displayed in place of the prompt
     * @type {string}
     * @memberof SuggestedPrompt
     */
    displayText?: string;
    /**
     * 
     * @type {string}
     * @memberof SuggestedPrompt
     */
    prompt: string;
    /**
     * 
     * @type {string}
     * @memberof SuggestedPrompt
     */
    type: string;
    /**
     * 
     * @type {boolean}
     * @memberof SuggestedPrompt
     */
    autoSubmit: boolean;
    /**
     * 
     * @type {string}
     * @memberof SuggestedPrompt
     */
    icon?: string;
    /**
     * 
     * @type {string}
     * @memberof SuggestedPrompt
     */
    iconColor?: string;
    /**
     * 
     * @type {boolean}
     * @memberof SuggestedPrompt
     */
    hidden?: boolean;
    /**
     * 
     * @type {string}
     * @memberof SuggestedPrompt
     */
    displayFormat: string;
    /**
     * 
     * @type {string}
     * @memberof SuggestedPrompt
     */
    url?: string;
}

/**
 * Check if a given object implements the SuggestedPrompt interface.
 */
export function instanceOfSuggestedPrompt(value: object): value is SuggestedPrompt {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('prompt' in value) || value['prompt'] === undefined) return false;
    if (!('type' in value) || value['type'] === undefined) return false;
    if (!('autoSubmit' in value) || value['autoSubmit'] === undefined) return false;
    if (!('displayFormat' in value) || value['displayFormat'] === undefined) return false;
    return true;
}

export function SuggestedPromptFromJSON(json: any): SuggestedPrompt {
    return SuggestedPromptFromJSONTyped(json, false);
}

export function SuggestedPromptFromJSONTyped(json: any, ignoreDiscriminator: boolean): SuggestedPrompt {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'displayText': json['displayText'] == null ? undefined : json['displayText'],
        'prompt': json['prompt'],
        'type': json['type'],
        'autoSubmit': json['autoSubmit'],
        'icon': json['icon'] == null ? undefined : json['icon'],
        'iconColor': json['iconColor'] == null ? undefined : json['iconColor'],
        'hidden': json['hidden'] == null ? undefined : json['hidden'],
        'displayFormat': json['displayFormat'],
        'url': json['url'] == null ? undefined : json['url'],
    };
}

export function SuggestedPromptToJSON(json: any): SuggestedPrompt {
    return SuggestedPromptToJSONTyped(json, false);
}

export function SuggestedPromptToJSONTyped(value?: SuggestedPrompt | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'displayText': value['displayText'],
        'prompt': value['prompt'],
        'type': value['type'],
        'autoSubmit': value['autoSubmit'],
        'icon': value['icon'],
        'iconColor': value['iconColor'],
        'hidden': value['hidden'],
        'displayFormat': value['displayFormat'],
        'url': value['url'],
    };
}

